<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="6" cols="7">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header">
                                <h3>{{title}}</h3>
                            </div>
                            <b-row>
                                 <b-col cols="3">
                                    <base-input :label="language_terms['ACCOUNT_TYPE']">
                                        <el-select
                                        v-model="account.type"
                                        filterable
                                        :placeholder="language_terms['ACCOUNT_TYPE']"
                                        :disabled="!isEdit">
                                        <el-option
                                            v-for="option in account_types"
                                            :key="option.code"
                                            :label="option.name"
                                            :value="option.code">
                                        </el-option>
                                        </el-select>
                                    </base-input>  
                                    <!-- <label class="form-control-label">{{language_terms['ACCOUNT_TYPE']}}</label>
                                    <multiselect
                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                        :placeholder="language_terms['SEARCH_ADD_TAG']"
                                        open-direction="bottom"
                                        label="name"
                                        track-by="code"
                                        :options="account_types"
                                        text-field="name"
                                        :multiple="false"
                                        v-model="account.account_type_obj"
                                        :taggable="false"
                                        :disabled="!isEdit"
                                        @input="onSelectAccountType"
                                    ></multiselect> -->
                                </b-col>
                                <b-col cols="3">
                                    <base-input :label="language_terms['ACCOUNT_CODE']" v-model="account.code" :disabled="!isEdit"></base-input>
                                </b-col>
                                <b-col cols="3">
                                    <base-input :label="language_terms['ACCOUNT_NAME']" v-model="account.name" :disabled="!isEdit"></base-input>
                                </b-col>
                                <b-col cols="3">
                                    <base-input :label="language_terms['FINANCIAL_YEAR']" v-model="account.fy" disabled type="number"></base-input>
                                </b-col>
                                <b-col cols="4">
                                    <base-input :label="language_terms['CURRENCY']">
                                        <el-select
                                            v-model="account.currency_code"
                                            filterable
                                            :placeholder="language_terms['CURRENCY']"
                                            :disabled="!isEdit">
                                        <el-option
                                            v-for="option in currencies"
                                            :key="option.code"
                                            :label="option.code + ' (' + option.prefix + ')'"
                                            :value="option.code">
                                        </el-option>
                                        </el-select>
                                    </base-input>                              
                                </b-col>
                                <b-col cols="4">
                                    <base-input :label="language_terms['OPENING_BALANCE']" v-model="account.opening_balance" :disabled="!isEdit" type="number"></base-input>
                                </b-col>
                                <b-col cols="4">
                                    <base-input :label="language_terms['CURRENT_BALANCE']" v-model="account.balance" disabled type="number"></base-input>
                                </b-col>

                                <b-col cols="2">
                                    <b-form-checkbox class="mb-3" v-model="account.is_taggable" value="1" unchecked-value="0" :disabled="!isEdit">
                                        Allow Sub Tag
                                    </b-form-checkbox>
                                </b-col>

                                <b-col cols="2">
                                    <b-form-checkbox class="mb-3" v-model="account.is_active" value="1" unchecked-value="0" :disabled="!isEdit">
                                        {{language_terms['IS_ACTIVE']}}
                                    </b-form-checkbox>
                                </b-col>

                                <b-col cols="12">
                                    <base-button type="primary" @click="edit" class="mt-4 mr-4" v-if="!isEdit">{{language_terms['EDIT']}}</base-button>
                                    <!-- <base-button type="success" @click="newVoucher" class="mt-4 mr-4" v-if="(account.fy != null && account.fy != '') && ($route.params.id != '_new')">{{language_terms['NEW_VOUCHER']}}</base-button> -->
                                    <base-button type="success" @click="save" class="mt-4 mr-4" v-if="isEdit">{{language_terms['SAVE']}}</base-button>
                                    <base-button type="warning" @click="deleteAccount" class="mt-4 mr-4">{{language_terms['DELETE']}}</base-button>
                                    <base-button type="danger" @click="cancel" class="mt-4">{{language_terms['CANCEL']}}</base-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Select, Option } from "element-ui";


export default {
    components:
    {
        Loading,
        [Select.name]: Select,
        [Option.name]: Option
    },
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            account_types: state => state.accounts.account_types,
            currencies: state => state.currencies.currencies,
            active_accounts:state => state.accounts.active_accounts,
            is_created: state => state.accounts.is_created,
            is_updated: state => state.accounts.is_updated,
            is_deleted: state => state.accounts.is_deleted,
            account_filter: state => state.accounts.filter,
            account_data: state => state.accounts.data
        })
    },
    data(){
        return{
            loading:false,
            title:"",
            isEdit:false,
            account:{
                account_type:"",
                account_type_obj:{},
                parent_account:{},
                parent_id:"",
                account_code:"",
                account_name:"",
                currency:{
                    code:"SGD",
                    name:"SGD"
                },
                currency_code:"SGD",
                opening_balance:null,
                balance:null,
                is_active:"1",
                fy:null,
            }
        }
    },
    async mounted()
    {
        let id = this.$route.params.id

        await this.$store.dispatch("accounts/fetchAccountTypes", {})
        await this.$store.dispatch("currencies/fetchAll", {})

        let query = this.$route.query.fy

        if(id == '_new')
        {
            await this.$store.dispatch('accounts/fetchActive', {id:-1})

            if(query == 'default')
            {
                this.account.fy = null
            }
            else
            {
                this.account.fy = query
            }
        }
        else
        {
            await this.$store.dispatch('accounts/fetchActive', {id:id})
            //this.account = this.account_data
        }


        if(id == '_new')
        {
            this.title = this.language_terms['NEW_ACCOUNT']
            this.isEdit = true
        }
        else
        {
            await this.$store.dispatch("accounts/fetch", {id:id})

            this.account = this.account_data
            this.title = this.account.code

        }
    },
    methods:{
        onSelectAccountType(selectedOption)
        {
            if(selectedOption)
            {
                this.account.account_type = selectedOption.code
            }
        },
        // onSelectCurrencyCode(selectedOption)
        // {
        //     if(selectedOption)
        //     {
        //         this.account.currency_code = selectedOption.code
        //     }
        // },
        onSelectParent(selectedOption)
        {
            if(selectedOption)
            {
                this.account.parent_id = selectedOption.id

            }
        },
        edit()
        {   
            this.isEdit = 1
        },
        newVoucher()
        {
            this.$router.push({ path: '/finance/voucher/_new' , query: { account_id: this.account.id} })
        },
        save()
        {
            if(this.$route.params.id == '_new')
            {
                this.create()
            }
            else
            {
                this.update()
            }
        },
        async create()
        {
            await this.$store.dispatch("accounts/create", this.account)

            if(this.is_created == 1)
            {
                this.$router.push("/finance/chart-of-accounts")
            }
        },
        async searchAccounts()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.account_filter)
            {
                filter = this.account_filter
            }
            await this.$store.dispatch('accounts/quickSearch', filter)

            this.loading = false
        },
        async update()
        {
            await this.$store.dispatch("accounts/update", this.account)

            if(this.is_updated == 1)
            {
                this.$router.push("/finance/chart-of-accounts")
            }

        },
        async deleteAccount()
        {
            await this.$store.dispatch("accounts/delete", this.account)

            if(this.is_deleted == 1)
            {
                this.$router.push("/finance/chart-of-accounts")
            }
        },
        cancel()
        {
            if(this.$route.params.id == '_new')
                this.$router.push("/finance/chart-of-accounts")
            else
                location.reload();
        }
    }
}
</script>
